import type {
  DiagnosticActivity,
  Review,
} from "@/services/api/odin/activities/diagnostic/study-session/update"
import { MultipleChoiceQuestion } from "./questions/multiple-choise"
import OpenEndedQuestion from "./questions/open-ended"
import AnalysisQuestion from "./questions/analysis"

interface DiagnosticQuestionsProps {
  isLoading: boolean
  activity: DiagnosticActivity
  displayReview: boolean
  review: Review
  onClickSendAnswer: (answer: string, correctAnswer: number) => void
  onClickNextQuestion: () => void
}

export default function DiagnosticQuestions({
  isLoading,
  review,
  displayReview,
  activity,
  onClickSendAnswer,
  onClickNextQuestion,
}: DiagnosticQuestionsProps) {
  function renderQuestionType(activity: DiagnosticActivity) {
    switch (activity.next.questionType) {
      case "multiple_choice":
        return (
          <MultipleChoiceQuestion
            review={review}
            isLoading={isLoading}
            displayReview={displayReview}
            options={activity.next.options}
            onClickSendAnswer={onClickSendAnswer}
            onClickNextQuestion={onClickNextQuestion}
          />
        )
      case "open_ended":
        return (
          <OpenEndedQuestion
            review={review}
            isLoading={isLoading}
            displayReview={displayReview}
            onClickSendAnswer={onClickSendAnswer}
            onClickNextQuestion={onClickNextQuestion}
          />
        )
      case "analysis":
        return (
          <AnalysisQuestion
            review={review}
            isLoading={isLoading}
            displayReview={displayReview}
            onClickSendAnswer={onClickSendAnswer}
            onClickNextQuestion={onClickNextQuestion}
          />
        )
      default:
        return null
    }
  }

  return (
    <div className="flex w-full items-center justify-center">
      <div className="w-full max-w-4xl">
        <div className="mb-8 text-lg text-neutral-800">{activity.next.question}</div>
        {renderQuestionType(activity)}
      </div>
    </div>
  )
}
